import { Component, computed, input, output, signal } from "@angular/core";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { PageInfo } from "../../../../../gql/generated-ingestor";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { PaginatorIntlService } from "./intl.service";

// @todo rename to PaginationExpanded or something
@Component({
  selector: "pagination-numbered",
  templateUrl: "numbered.html",
  styleUrls: ["../../pagination.scss"],
  imports: [MatPaginatorModule, TranslateModule, AngularSvgIconModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntlService,
    },
  ],
})
export class PaginationNumbered {
  public pageInfo = input<PageInfo>({
    filterFields: [],
    hasNextPage: false,
    hasPreviousPage: false,
    sortFields: [],
    endCursor: 0,
    startCursor: 0,
    totalItems: 0,
  });
  public pageChange = output<number>();
  public pageSizeChanged = output<number>();
  protected itemsPerPage = signal(10);
  protected totalItems = computed(() => this.pageInfo().totalItems);
  private startCursor = computed(() => this.pageInfo().startCursor);

  constructor() {
    this.loadPreference();
  }

  private pageToCursor(v: number): number {
    if (this.pageInfo().totalItems === 0) {
      return 1;
    }

    return Math.floor(v * this.itemsPerPage());
  }

  handlePageEvent($event: PageEvent) {
    if ($event.pageSize !== this.itemsPerPage()) {
      this.storePreference($event.pageSize);
    } else {
      this.goToPage($event.pageIndex);
    }
  }

  goToPage(v: number) {
    this.pageChange.emit(this.pageToCursor(v));
  }

  prevPage() {
    this.pageChange.emit(this.startCursor() - this.itemsPerPage());
  }

  nextPage() {
    this.pageChange.emit(this.startCursor() + this.itemsPerPage());
  }

  loadPreference() {
    const stored = Number(localStorage.getItem("paginationSize") ?? 10);
    this.itemsPerPage.set(stored);
  }

  storePreference(v: number) {
    localStorage.setItem("paginationSize", v.toString());
    this.pageSizeChanged.emit(v);
  }
}
